
import axios from 'axios'

const apiClient = axios.create({
  timeout: 10000,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

function getAPIURL () {
  return window.sessionStorage.getItem('bgbackend_apiUrl')
}

function getToken () {
  return window.sessionStorage.getItem('bgbackend_token')
}

export default {
  getRegistrationsByDate (betgame) {
    return apiClient.get(getAPIURL() + '/bg_v_registrations_by_date?fk_betgame=eq.' + betgame + '&order=date',
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getUserStatistics (betgame) {
    return apiClient.get(getAPIURL() + '/bg_v_user_statistics?fk_betgame=eq.' + betgame + '&order=matchday',
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getMatchdayRanking (betgame, competition, matchday, limit) {
    return apiClient.get(getAPIURL() + '/bg_v_matchday_ranking?fk_betgame=eq.' + betgame + '&fk_competition=eq.' + competition +
      '&matchday=eq.' + matchday + '&limit=' + limit + '&order=points_total.desc,exact.desc',
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getBetgame (betgame) {
    return apiClient.get(getAPIURL() + '/bg_betgame?id=eq.' + betgame,
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getOwner (user) {
    return apiClient.get(getAPIURL() + '/bg_betgame?select=fk_user,id,name&fk_user=eq.' + user,
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getAuthor (user) {
    return apiClient.get(getAPIURL() + '/bg_author?select=fk_user,fk_betgame,bg_betgame(name)&fk_user=eq.' + user,
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getBetgameCompetition (betgame) {
    return apiClient.get(getAPIURL() + '/bg_betgame_competition?fk_betgame=eq.' + betgame,
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getLastMatchday (competition) {
    return apiClient.get(getAPIURL() + '/bg_v_schedule?select=matchday&fk_competition=eq.' + competition + '&and=(goalshome.not.is.null,goalshome.not.is.null)&order=matchday.desc&limit=1',
      {
        headers: {Authorization: 'Bearer ' + getToken()}
      }
    )
  },
  getUsers (betgame, offset, limit) {
    if (offset > -1 && limit > -1) {
      return apiClient.get(getAPIURL() + '/bg_user_betgame?select=bg_user(id,nickname,firstname,lastname,email,source,status,address,zip,city,allow_email)&fk_user=not.in.(1,93)&fk_betgame=eq.' + betgame + '&order=fk_user&offset=' + offset + '&limit=' + limit,
        {
          headers: {
            Authorization: 'Bearer ' + getToken(),
            Prefer: 'count=exact'
          }
        }
      )
    } else {
      return apiClient.get(getAPIURL() + '/bg_user_betgame?select=bg_user(id,nickname,firstname,lastname,email,source,status,address,zip,city,allow_email)&fk_user=not.in.(1,93)&fk_betgame=eq.' + betgame + '&order=fk_user',
        {
          headers: {
            Authorization: 'Bearer ' + getToken(),
            Prefer: 'count=exact'
          }
        }
      )
    }
  },
  getQuestions (betgame, offset, limit) {
    if (offset > -1 && limit > -1) {
      return apiClient.get(getAPIURL() + '/bg_question?select=id,question,type,points,answer_count,fk_betgame,editable_until,options&fk_betgame=eq.' + betgame + '&order=id&offset=' + offset + '&limit=' + limit,
        {
          headers: {
            Authorization: 'Bearer ' + getToken(),
            Prefer: 'count=exact'
          }
        }
      )
    } else {
      return apiClient.get(getAPIURL() + '/bg_question?select=id,question,type,points,answer_count,fk_betgame,editable_until,options&fk_betgame=eq.' + betgame + '&order=id',
        {
          headers: {
            Authorization: 'Bearer ' + getToken(),
            Prefer: 'count=exact'
          }
        }
      )
    }
  },
  patchUser (id, data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json; charset=utf-8' }
    }
    return apiClient.patch(getAPIURL() + '/bg_user?id=eq.' + id, JSON.stringify(data), config)
  },
  requestPasswordReset (data) {
    var config = {
      headers: { 'Content-Type': 'application/json' }
    }
    return apiClient.post(getAPIURL() + '/rpc/request_password_reset', JSON.stringify(data), config)
  },
  resendValidationEmail (data) {
    var config = {
      headers: { 'Content-Type': 'application/json' }
    }
    return apiClient.post(getAPIURL() + '/rpc/resend_validation_email', JSON.stringify(data), config)
  },
  postUser (data) {
    if (data.id !== undefined && data.id !== null) {
      return
    }
    var config = {
      headers: { 'Content-Type': 'application/json; charset=utf-8' }
    }
    return apiClient.post(getAPIURL() + '/bg_user', JSON.stringify(data), config)
  },
  postUserBetgame (user, betgame) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json; charset=utf-8' }
    }
    return apiClient.post(getAPIURL() + '/bg_user_betgame', { fk_user: parseInt(user), fk_betgame: parseInt(betgame) }, config)
  },
  deleteUser (data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json; charset=utf-8' }
    }
    return apiClient.post(getAPIURL() + '/rpc/backend_delete_account', JSON.stringify(data), config)
  },
  patchBetgame (id, data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.patch(getAPIURL() + '/bg_betgame?id=eq.' + id, JSON.stringify(data), config)
  },
  postQuestion (data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(),
        'Content-Type': 'application/json',
        'Prefer': 'return=representation' }
    }
    return apiClient.post(getAPIURL() + '/bg_question?select=id', JSON.stringify(data), config)
  },
  patchQuestion (id, data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.patch(getAPIURL() + '/bg_question?id=eq.' + id, JSON.stringify(data), config)
  },
  deleteQuestion (questionId, betgameId) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.delete(getAPIURL() + '/bg_question?id=eq.' + questionId + '&fk_betgame=eq.' + betgameId, config)
  },
  fetchCompetitionTeams (competiton) {
    return apiClient.get(getAPIURL() + '/bg_competition_team?select=bg_team(*)&fk_competition=eq.' + competiton)
  },
  uploadBetgameIcon (file, config) {
    return apiClient.post(getAPIURL() + '/upload', file, config)
  },
  getBetgameSlides (betgameId) {
    return apiClient.get(getAPIURL() + '/bg_betgame_slide?fk_betgame=eq.' + betgameId + '&order=position.asc')
  },
  getBetgameAds (betgameId) {
    return apiClient.get(getAPIURL() + '/bg_betgame_ad?fk_betgame=eq.' + betgameId + '&order=position.asc')
  },
  getCompetition (id) {
    return apiClient.get(getAPIURL() + '/bg_competition?id=eq.' + id)
  },
  patchBetgameAd (id, data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.patch(getAPIURL() + '/bg_betgame_ad?id=eq.' + id, JSON.stringify(data), config)
  },
  patchBetgameSlide (id, data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.patch(getAPIURL() + '/bg_betgame_slide?id=eq.' + id, JSON.stringify(data), config)
  },
  uploadBetgameSlide (file, config) {
    return apiClient.post(getAPIURL() + '/uploadslide', file, config)
  },
  uploadBetgameAd (file, config) {
    return apiClient.post(getAPIURL() + '/uploadad', file, config)
  },
  getSchedule (leagueId, seasonId) {
    return apiClient.get(getAPIURL() +
      '/bg_v_schedule?fk_competition=eq.' + leagueId + '&fk_season=eq.' + seasonId
    )
  },
  fetchTournamentMatches (competiton) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.get(getAPIURL() + '/bg_tournament_match?fk_competition=eq.' + competiton, config)
  },
  getSolutions (questionIDs) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.get(getAPIURL() + '/bg_solution?fk_question=in.(' + questionIDs + ')', config)
  },
  deleteSolutions (data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.delete(getAPIURL() + '/bg_solution?fk_question=eq.' + data.fk_question, config)
  },
  postSolution (data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.post(getAPIURL() + '/bg_solution', JSON.stringify(data), config)
  },
  deleteAnswers (question) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.delete(getAPIURL() + '/bg_answer?fk_question=eq.' + question, config)
  },
  putUserBetgamePoints (data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.put(getAPIURL() + '/bg_user_betgame_points?fk_user=eq.' + data.fk_user + '&fk_betgame=eq.' + data.fk_betgame, JSON.stringify(data), config)
  },
  fetchUserBetgamePoints (betgame) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.get(getAPIURL() + '/bg_user_betgame_points?fk_betgame=eq.' + betgame, config)
  },
  deletUserBetgamePoints (data) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.delete(getAPIURL() + '/bg_user_betgame_points?fk_user=eq.' + data.fk_user + '&fk_betgame=eq.' + data.fk_betgame, config)
  },
  fetchTotalRankings (betgame) {
    var config = {
      headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }
    return apiClient.get(getAPIURL() + '/bg_v_ranking?select=position,fk_betgame,fk_user,user_name,user_email,points_total,matchday_wins,exact,goaldiff,tendency,no_points,betcount,question_points,points_correction&' +
      'order=position.asc&fk_betgame=eq.' + betgame + '&order=points_total.desc,matchday_wins.desc,exact.desc,goaldiff.desc,tendency.desc,no_points.desc,betcount.desc,fk_user.desc', config)
  }
}




// WEBPACK FOOTER //
// ./src/services/APIService.js